import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { Col, Row } from "react-bootstrap";
import TableSchedules from "../../components/table/TableSchedules";

import { tr } from "../../i18n";
const TabSchedules = () => {
  return (
    <div>
      <Row>
        <Col lg={12} className="mb-4 mt-3">
          <Row>
            <Col lg={12}>
              <div className="d-flex gap-3 justify-content-end">
                <Link
                  to="/schedules/form"
                  className="btn btn-primary d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm fw-small"
                >
                  <FontAwesomeIcon icon={faPlus} />
                  {tr("attendance:create_schedule")}
                </Link>
              </div>
            </Col>
          </Row>
        </Col>
        <Col lg={12}>
          <TableSchedules />
        </Col>
      </Row>
    </div>
  );
};

export default TabSchedules;
